import script from "./CategoryTmall.vue?vue&type=script&lang=ts&setup=true"
export * from "./CategoryTmall.vue?vue&type=script&lang=ts&setup=true"

import "./CategoryTmall.vue?vue&type=style&index=0&id=1c2d1ead&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c2d1ead"]])

export default __exports__